module.exports = __webpack_public_path__ + "img/8f18032.svg";